import type { HostedAgentWizardTab } from "./hosted-agents"

export const HOSTED_AGENT_STEPS: { id: string; tabs: HostedAgentWizardTab[] }[] = [
  { id: "mission", tabs: ["profile", "instructions"] },
  { id: "knowledge", tabs: ["sources", "libraries"] },
  { id: "permissions", tabs: ["access", "tools", "memory", "budget"] },
  { id: "try", tabs: ["test", "evals"] },
  { id: "publish", tabs: ["publish"] },
  { id: "advanced", tabs: ["model", "skills", "routines", "lifecycle", "raw"] },
]
